import { render, staticRenderFns } from "./multiBrand.vue?vue&type=template&id=74573c43&scoped=true"
import script from "./multiBrand.vue?vue&type=script&lang=js"
export * from "./multiBrand.vue?vue&type=script&lang=js"
import style0 from "./multiBrand.vue?vue&type=style&index=0&id=74573c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74573c43",
  null
  
)

export default component.exports